import React, {useState} from 'react'
import { useHistory } from "react-router-dom"
import Header from "./Header"
import "./total.css"
import { Icon, InlineIcon } from '@iconify/react';
import calculatorIcon from '@iconify-icons/entypo/calculator';
import {Grid} from "@material-ui/core"

function Total() {

    const [weight, setWeight] = useState("");
    //infusion rate
    const [vamin, setVamin] = useState("");
    const [lipid, setLipid] = useState("");
    //regimen ordered
    const [fluid, setFluid] = useState("");
    const [dextrose, setDextrose] = useState("");
    const [protein, setProtein] = useState("");
    const [lipid1, setLipid1] = useState("");


    
    var total_fluids = ((vamin * 24) + (lipid * 24)).toFixed(1)

    //order volume
    var lipidOV = (lipid1 * weight) / 0.2 
    localStorage.setItem("lipidOV", lipidOV)
    var vaminOV = fluid - lipidOV
    localStorage.setItem("vaminOV", vaminOV)

    //calorie calculation
    var dextroseCC = (((0.346 / 10) * dextrose) * (vamin * 24)).toFixed(2)
    localStorage.setItem("dextroseCC", dextroseCC)
    var proteinCC = (((protein * weight * 4 ) / vaminOV) * (vamin * 24)).toFixed(2)
    localStorage.setItem("proteinCC", proteinCC)
    var fatCC = (((lipid1 * weight) * 9 / lipidOV) * (lipid * 24)).toFixed(2)
    localStorage.setItem("fatCC", fatCC)


    //bring forward to CalcuTotal.js

    //standard value of LL
    var LL = 90
    localStorage.setItem("LL", LL)
    //standard value of UL
    var UL = 120
    localStorage.setItem("UL", UL)

    

    const day1oflife = (event) => {
      //LL and UL change const val
      console.log("LL and UL const different dol1 and dol>=2 ")
      console.log("old UL",LL)
      var LL = 45
      console.log("new LL",LL)
      localStorage.setItem("LL", LL)

      console.log("old UL",UL)
      var UL = 55
      localStorage.setItem("UL", UL)
      console.log("new UL",UL)
    }

    let history = useHistory();
  
    const calculate = () => {
      //console.log(data)
        history.push("/calculate-total")
    }

    const handleWeight = (event) => {
        setWeight(event.target.value);
        localStorage.setItem("current weight", event.target.value);
   
      };

      const handleVamin = (event) => {
        setVamin(event.target.value);
        localStorage.setItem("vamin", event.target.value);
      };

      const handleLipid = (event) => {
        setLipid(event.target.value);
        localStorage.setItem("lipid", event.target.value);
      };

      const handleFluid = (event) => {
        setFluid(event.target.value);
        localStorage.setItem("fluid", event.target.value);
      };

      const handleDextrose = (event) => {
        setDextrose(event.target.value);
        localStorage.setItem("dextrose", event.target.value);
      };

      const handleProtein = (event) => {
        setProtein(event.target.value);
        localStorage.setItem("protein", event.target.value);
      };

      const handleLipid1 = (event) => {
        setLipid1(event.target.value);
        localStorage.setItem("lipid1", event.target.value);
      };


    



    return (
        <div className="row">
        <div className = "col-md-12">
        <div className = "total__page">
        <Header/>
        <div className="total__content">
          
          <div className = "header__topic">
            <h4>Total Parenteral Nutrition</h4>
          </div>
            <form onSubmit= {calculate}>
            <label>Please insert information into the cells</label>

          <Grid container spacing = {5}>
            <Grid item xs={5}>
              <div>Current Weight (kg) </div>
            </Grid>
            <Grid item xs={3}>
                <input required step="any" pattern = "^(\d*\.)?\d+$"  className = "input__weight1"  size = "6"  type = "number" placeholder = "0.000"
                onChange = {handleWeight} value = {weight}/> 
            </Grid>
          </Grid>

            <div className = "infusion__rate">
                <strong>INFUSION RATE</strong>
            </div>

                  <Grid container spacing = {5}>      
                    <Grid item xs={5}>         
                      <div className = "space__bottom">Vamin (ml/hr) </div>
                    </Grid>
                    <Grid item xs={3}> 
                      <input required className = "input__vamin"  size = "6" type = "number" step="any" pattern = "^(\d*\.)?\d+$" placeholder = "0.000"
                      onChange = {handleVamin} value = {vamin}/>
                    </Grid>
                  </Grid>

                  <Grid container spacing = {5}>
                    <Grid item xs={5}>    
                      <div className = "space__bottom">Lipid (ml/hr)</div>
                    </Grid>
                    <Grid item xs={3}>    
                      <input required className="input__lipid"  size = "6" type = "number" step="any" pattern = "^(\d*\.)?\d+$" placeholder = "0.0"
                      onChange = {handleLipid} value = {lipid}/>
                    </Grid>
                  </Grid> 

                  <Grid container spacing = {5}>
                    <Grid item xs={5}>
                       <div className = "space__bottom">Total fluids in a day (ml) </div>
                     </Grid>
                     <Grid item xs={3}>
                      <button className = "total__fluid">{total_fluids}</button>
                     </Grid>
                  </Grid>
            
            <div className = "regimen__ordered">
                <strong>REGIMEN ORDERED</strong> 
            </div>

              <Grid container spacing = {5}>
                  <Grid item xs={5}>
                    <div className = "space__bottom">Fluid for TPN (ml)</div>
                  </Grid>
                  <Grid item xs={3}>
                    <input required onChange = {handleFluid} value = {fluid} placeholder = "0.0" className="input__fluid" size = "6"  type = "number" step="any"  pattern = "^(\d*\.)?\d+$"/> 
                  </Grid>
              </Grid>


                <Grid container spacing = {5}>
                  <Grid item xs={5}>
                    <div className = "space__bottom">Dextrose(%)</div> 
                  </Grid>
                  <Grid item xs={3}>
                    <input required onChange = {handleDextrose} value = {dextrose} placeholder = "0.0" className="input__dextrose" size = "6"  type = "number"  step="any" pattern = "^(\d*\.)?\d+$"/> 
                  </Grid>
                </Grid>
                
                <Grid container spacing = {5}>
                  < Grid item xs={5}>
                      <div className = "space__bottom">Protein (g/kg) </div>
                    </Grid>
                    <Grid item xs={3}>
                      <input required onChange = {handleProtein} value = {protein} placeholder = "0.0" className="input__protein"size = "6"  type = "number" step="any" pattern = "^(\d*\.)?\d+$" /> 
                     </Grid>
                </Grid>

                <Grid container spacing = {5}>
                  <Grid item xs={5}>
                    <div className = "space__bottom">Lipid (g/kg) </div> 
                  </Grid>
                  <Grid item xs={3}>
                    <input required onChange = {handleLipid1} value = {lipid1} className="input__lipid1" placeholder= "0.0" size = "6"  type = "number" step="any" pattern = "^(\d*\.)?\d+$" /> 
                  </Grid>
                </Grid>

            <div className = "space__top"> 
            <input onChange ={day1oflife}  type = "checkbox" className = "patient__day1"/>  Tick if patient is Day 1 of life
            </div>
            
            <Grid container spacing = {1}>
                <button  className = "calculate__energy" onSubmit ={calculate}>
                  <Icon icon={calculatorIcon} />  Calculate
                </button>
            </Grid>
            </form>
            </div>
        </div>
        </div>
        </div>
    )
}

export default Total
